<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-page-header content="支付流水上传"></el-page-header>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">
      <div class="container">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 20px;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>支付流水上传</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="header">
          <h1>大数据量支付流水上传系统</h1>
          <p>支持Excel/CSV文件上传，分块处理与数据库存储</p>
        </div>

        <div class="main-content">
          <!-- 上传区域 -->
          <div class="upload-section">
            <div class="section-title">
              <i class="el-icon-upload"></i>
              文件上传
            </div>

            <div class="file-type-tabs">
              <div class="file-type-tab" :class="{active: activeTab === 'excel'}" @click="activeTab = 'excel'">Excel上传</div>
              <div class="file-type-tab" :class="{active: activeTab === 'csv'}" @click="activeTab = 'csv'">CSV上传</div>
            </div>

            <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :auto-upload="false"
                    :on-change="handleFileChange"
                    :accept="activeTab === 'excel' ? '.xlsx, .xls' : '.csv'"
                    :limit="1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将{{activeTab === 'excel' ? 'Excel' : 'CSV'}}文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">支持{{activeTab === 'excel' ? 'xlsx、xls' : 'csv'}}格式文件，最大支持2GB文件</div>
            </el-upload>


            <div>
              <el-form :model="form" :rules="rules" ref="form" label-width="120px" size="mini">
                <el-form-item label="所属代理商" required >

                  <el-input  placeholder="请选择所属代理商" v-model="form.proxy_name" :readonly="true"  @click.native="cProxy" clearable type="text">
                    <i slot="suffix" class="el-icon-more"></i>
                  </el-input>
                </el-form-item>
                <el-form-item label="所属支付渠道" required>
                  <el-select

                          v-model="form.pay_source_id"
                          placeholder="请选择所属支付渠道"
                          @change="changeRoleNameValue($event)"
                  >
                    <el-option v-for="item in paySourceList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
<!--            <div class="upload-tips" v-if="activeTab === 'excel'">-->
<!--              <p>大数据量上传说明：</p>-->
<!--              <p>1. 系统将自动分块处理大文件，每块{{chunkSize}}条记录</p>-->
<!--              <p>2. 处理过程中可以继续其他操作</p>-->
<!--              <p>3. 数据将分批保存到数据库，避免内存溢出</p>-->
<!--              <p>4. 支持暂停和继续上传过程</p>-->
<!--            </div>-->

<!--            <div class="upload-tips" v-else>-->
<!--              <p>CSV大数据量上传说明：</p>-->
<!--              <p>1. 系统将流式读取CSV文件，分块处理</p>-->
<!--              <p>2. 支持GB级别的CSV文件上传</p>-->
<!--              <p>3. 数据将分批保存到数据库</p>-->
<!--              <p>4. 支持暂停和继续上传过程</p>-->
<!--            </div>-->

            <div v-if="file" class="file-info">
              <p>已选择文件: {{ file.name }}</p>
              <p>文件大小: {{ formatFileSize(file.size) }}</p>
              <p>文件类型: {{ file.type || getFileType(file.name) }}</p>
              <p>预计记录数: {{ estimatedRecords }}</p>
            </div>

            <div class="action-buttons">
              <el-button type="primary" icon="el-icon-upload" @click="startProcessing" :disabled="!file || processing">
                开始处理
              </el-button>
              <el-button type="warning" icon="el-icon-video-pause" @click="pauseProcessing" :disabled="!processing || paused">
                {{paused ? '已暂停' : '暂停处理'}}
              </el-button>
              <el-button type="success" icon="el-icon-caret-right" @click="resumeProcessing" :disabled="!paused">
                继续处理
              </el-button>
              <el-button icon="el-icon-delete" @click="clearData">
                清空数据
              </el-button>
            </div>

            <div v-if="processing" class="progress-section">
              <div class="section-title">
                <i class="el-icon-loading"></i>
                处理进度
              </div>

              <el-progress :percentage="overallProgress" :status="progressStatus"></el-progress>

              <div class="chunk-info">
                <span>当前块: {{currentChunk}}/{{totalChunks}}</span>
                <span>已处理: {{processedRecords}}/{{totalRecords}}</span>
              </div>

              <div class="database-status">
                <div class="status-item">
                  <span>数据库连接:</span>
                  <span class="status-value status-complete">正常</span>
                </div>
                <div class="status-item">
                  <span>当前操作:</span>
                  <span class="status-value status-processing">{{currentOperation}}</span>
                </div>
                <div class="status-item">
                  <span>处理速度:</span>
                  <span class="status-value">{{processingSpeed}} 条/秒</span>
                </div>
                <div class="status-item">
                  <span>预计剩余时间:</span>
                  <span class="status-value">{{estimatedTimeRemaining}}</span>
                </div>
              </div>
            </div>

            <div v-if="uploadSuccess" class="success-message">
              <i class="el-icon-success"></i>
              <span>文件处理成功！共处理 {{ totalRecords }} 条数据</span>
            </div>
          </div>

          <!-- 预览区域 -->
          <div class="preview-section">
            <div class="section-title">
              <i class="el-icon-document"></i>
              数据预览
            </div>

            <div v-if="tableData.length === 0" class="no-data">
              <i class="el-icon-document"></i>
              <p>暂无数据，请上传{{activeTab === 'excel' ? 'Excel' : 'CSV'}}文件</p>
            </div>

            <div v-else>
              <el-table
                      :data="tableData"
                      border
                      stripe
                      class="preview-table"
                      max-height="400"
                      ref="myTable"
              >
                <el-table-column
                        v-for="(header, index) in tableHeader"
                        :key="index"
                        :prop="header"
                        :label="header"
                        min-width="120"
                >
                </el-table-column>
              </el-table>

              <div style="margin-top: 15px; text-align: center; color: #909399;" v-if="totalRecords > 10">
                仅显示前10条记录，共 {{ totalRecords }} 条记录
              </div>

              <div class="stats-container">
                <div class="stat-card">
                  <div class="stat-label">总记录数</div>
                  <div class="stat-value">{{ totalRecords }}</div>
                </div>
                <div class="stat-card">
                  <div class="stat-label">已处理</div>
                  <div class="stat-value">{{ processedRecords }}</div>
                </div>
                <div class="stat-card">
                  <div class="stat-label">成功</div>
                  <div class="stat-value">{{ successRecords }}</div>
                </div>
                <div class="stat-card">
                  <div class="stat-label">失败</div>
                  <div class="stat-value">{{ errorRecords }}</div>
                </div>
              </div>

              <div class="action-buttons">
                <el-button type="primary" icon="el-icon-download" @click="exportData">
                  导出数据
                </el-button>
                <el-button type="success" icon="el-icon-check" @click="submitToDatabase" :disabled="processing">
                  提交到数据库
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="footer">
          <p>© 2023 大数据量支付流水上传系统 | 技术支持: bigdata@example.com</p>
        </div>
      </div>
    </el-card>

    <eProxyList
            :formData="formData2"
            :visible.sync="visible2"
            :title="title2"
            v-on:eventChoose="chooseProxy"
            :closeForm="closeForm2"
    />

  </div>
</template>
<script>
  import eProxyList from "../../common/eProxyList"
  import Papa from 'papaparse';
  import * as XLSX from 'xlsx';
  export default {
    name: "uploadPayExcel",
    components: { eProxyList},
    data() {
      return {
        paySourceList:[],
        formData2:{pid:''},
        title2:'',
        visible2:false,
        form:{
          proxy_id:'',
          proxy_name:'',
          pay_source_id:'',

        },
        rules:{

        },
        file: null,
        tableHeader: [],
        tableData: [],
        uploadSuccess: false,
        activeTab: 'excel',
        processing: false,
        paused: false,
        chunkSize: 1000, // 每块处理1000条记录
        currentChunk: 0,
        totalChunks: 0,
        processedRecords: 0,
        totalRecords: 0,
        successRecords: 0,
        errorRecords: 0,
        overallProgress: 0,
        currentOperation: '等待中',
        processingSpeed: 0,
        processingInterval: null,
        startTime: null,
        estimatedTimeRemaining: '计算中...'
      }
    },
    computed: {
      progressStatus() {
        if (this.overallProgress === 100) return 'success';
        if (this.paused) return 'warning';
        return null;
      },
      estimatedRecords() {
        if (!this.file) return 0;
        // 根据文件大小估算记录数 (假设每条记录大约100字节)
        return Math.round(this.file.size / 100);
      }
    },
    created() {
     this.getProxyList();
    },
    methods: {
      closeForm2(){
        this.visible2=false;
      },
      cProxy(){
        this.title2="选择所属代理";
        this.visible2=true;
        this.formData2.pid=sessionStorage.getItem('proxy_id');
        console.log( this.formData2.pid)
      },
     chooseProxy(id,...params){
        this.form.proxy_id=id;
        this.form.proxy_name=params[0];
      },
      getProxyList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findPaySourceList(param).then(res=>{
          if(res.code == 200){
            this.paySourceList = res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      formatFileSize(size) {
        if (size < 1024) {
          return size + ' B';
        } else if (size < 1024 * 1024) {
          return (size / 1024).toFixed(2) + ' KB';
        } else if (size < 1024 * 1024 * 1024) {
          return (size / (1024 * 1024)).toFixed(2) + ' MB';
        } else {
          return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
        }
      },
      getFileType(filename) {
        const extension = filename.split('.').pop().toLowerCase();
        if (extension === 'xlsx' || extension === 'xls') {
          return 'Excel文件';
        } else if (extension === 'csv') {
          return 'CSV文件';
        }
        return '未知文件类型';
      },
      // 处理文件变化
      handleFileChange(file) {
        this.file = file.raw;
        this.uploadSuccess = false;
        this.tableData = [];
        if (!this.file) {
          this.$message.error('请选择文件');
          return;
        }
        // 只预览前10条数据
        this.previewFile();
      },
      // 预览文件前10条数据
      previewFile() {
        const fileReader = new FileReader();
        const fileExtension = this.file.name.split('.').pop().toLowerCase();

        fileReader.onload = (e) => {
          try {
            if (fileExtension === 'csv') {
              // 处理CSV文件预览
              if (typeof Papa === 'undefined') {
                this.$message.error('CSV解析库未正确加载，请刷新页面重试');
                return;
              }

              const csvData = Papa.parse(e.target.result, {
                header: true,
                skipEmptyLines: true,
                encoding: 'UTF-8',
                preview: 10 // 只预览前10条
              });

              if (csvData.data.length > 0) {
                this.tableHeader = Object.keys(csvData.data[0]);
                this.tableData = csvData.data;
                this.totalRecords = csvData.meta.cursor;
              } else {
                this.$message.error('CSV文件中没有数据');
              }
            } else {
              // 处理Excel文件预览
              const data = new Uint8Array(e.target.result);
              const workbook = XLSX.read(data, { type: 'array' });

              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              // 转换为JSON
              const jsonData = XLSX.utils.sheet_to_json(worksheet);

              if (jsonData.length > 0) {
                // 获取表头
                this.tableHeader = Object.keys(jsonData[0]);
                this.tableData = jsonData.slice(0, 10); // 只预览前10条
                this.totalRecords = jsonData.length;
              } else {
                this.$message.error('Excel文件中没有数据');
              }
            }
          } catch (err) {
            console.error(err);
            this.$message.error('文件解析失败：' + err.message);
          }
        };

        if (fileExtension === 'csv') {
          fileReader.readAsText(this.file, 'UTF-8');
        } else {
          fileReader.readAsArrayBuffer(this.file);
        }
      },

      // 开始处理文件
      startProcessing() {
        if (!this.file) {
          this.$message.error('请先选择文件');
          return;
        }

        this.processing = true;
        this.paused = false;
        this.currentOperation = '解析文件中';
        this.startTime = new Date();

        // 计算总块数
        this.totalChunks = Math.ceil(this.totalRecords / this.chunkSize);

        // 模拟处理过程
        this.processChunks();
      },

      // 处理数据块
      processChunks() {
        if (this.paused) return;

        this.currentOperation = '处理数据块';

        // 模拟处理速度
        this.processingSpeed = Math.floor(Math.random() * 500) + 500;

        // 更新进度
        this.processingInterval = setInterval(() => {
          if (this.paused) {
            clearInterval(this.processingInterval);
            return;
          }

          this.processedRecords += Math.floor(this.processingSpeed / 10);
          this.successRecords = this.processedRecords - this.errorRecords;

          if (this.processedRecords > this.totalRecords) {
            this.processedRecords = this.totalRecords;
            this.successRecords = this.totalRecords - this.errorRecords;
            this.finishProcessing();
            return;
          }

          this.currentChunk = Math.ceil(this.processedRecords / this.chunkSize);
          this.overallProgress = Math.floor((this.processedRecords / this.totalRecords) * 100);

          // 计算预计剩余时间
          this.calculateRemainingTime();
        }, 100);
      },

      // 计算预计剩余时间
      calculateRemainingTime() {
        const elapsedTime = (new Date() - this.startTime) / 1000; // 秒
        const recordsPerSecond = this.processedRecords / elapsedTime;
        const remainingRecords = this.totalRecords - this.processedRecords;
        const remainingTime = remainingRecords / recordsPerSecond;

        if (remainingTime < 60) {
          this.estimatedTimeRemaining = Math.ceil(remainingTime) + '秒';
        } else if (remainingTime < 3600) {
          this.estimatedTimeRemaining = Math.ceil(remainingTime / 60) + '分钟';
        } else {
          this.estimatedTimeRemaining = Math.ceil(remainingTime / 3600) + '小时';
        }
      },

      // 暂停处理
      pauseProcessing() {
        if (!this.processing || this.paused) return;

        this.paused = true;
        this.currentOperation = '已暂停';
        clearInterval(this.processingInterval);
        this.$message.warning('处理已暂停');
      },

      // 继续处理
      resumeProcessing() {
        if (!this.paused) return;

        this.paused = false;
        this.currentOperation = '处理数据块';
        this.processChunks();
        this.$message.info('处理继续');
      },

      // 完成处理
      finishProcessing() {
        clearInterval(this.processingInterval);
        this.processing = false;
        this.overallProgress = 100;
        this.currentOperation = '处理完成';
        this.uploadSuccess = true;
        this.$message.success('文件处理完成！共处理 ' + this.totalRecords + ' 条记录');
      },

      // 导出数据
      exportData() {
        if (this.tableData.length === 0) {
          this.$message.warning('没有数据可导出');
          return;
        }

        // 创建工作簿
        const worksheet = XLSX.utils.json_to_sheet(this.tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "支付流水数据");

        // 生成Excel文件并下载
        XLSX.writeFile(workbook, "支付流水数据.xlsx");
        this.$message.success('数据导出成功！');
      },

      // 提交到数据库
      submitToDatabase() {
        if (this.tableData.length === 0) {

          this.$message.warning('没有数据可提交');
          return;
        }

        // 模拟提交到数据库的过程
        this.$message({
          message: '开始将数据保存到数据库...'+this.tableData.length,
          type: 'info'
        });

        // let param={
        //   proxy_id:this.form.proxy_id,
        //   pay_source_id: this.form.pay_source_id,
        //   company_id:sessionStorage.getItem('company_id'),
        //   access_token:sessionStorage.getItem('access_token'),
        // }

        // for(let i=1;this.tableData.length;i++){
        //   console.log(this.tableData)
        // }

        // this.$axios.payIcbcSaveAll(param).then(res=>{
        //    if(res.code==200){
        //       console.log('cccc');
        //    }
        // })
        // 模拟数据库存储
        // setTimeout(() => {
        //
        //   this.$message.success('数据已成功保存到数据库！共保存 ' + this.totalRecords + ' 条记录');
        // }, 2000);
      },

      // 清空数据
      clearData() {
        this.$confirm('确定要清空所有数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData = [];
          this.tableHeader = [];
          this.uploadSuccess = false;
          this.file = null;
          this.processing = false;
          this.paused = false;
          this.processedRecords = 0;
          this.totalRecords = 0;
          this.successRecords = 0;
          this.errorRecords = 0;
          this.overallProgress = 0;
          this.currentOperation = '等待中';
          clearInterval(this.processingInterval);
          this.$message.info('已清空数据');
        }).catch(() => {
          this.$message.info('已取消清空操作');
        });
      }
    }

  };
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
  }

  body {
    background-color: #f5f7fa;
    color: #606266;
    padding: 20px;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .header {
    text-align: center;
    margin-bottom: 20px;
    padding: 10px;
    background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
    border-radius: 8px;
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .header h1 {
    font-size: 28px;
    margin-bottom: 10px;
  }

  .header p {
    font-size: 16px;
    opacity: 0.9;
  }

  .main-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
  }

  .upload-section, .preview-section {
    flex: 1;
    min-width: 300px;
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .section-title {
    font-size: 18px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    color: #67c23a;
    display: flex;
    align-items: center;
  }

  .section-title i {
    margin-right: 10px;
  }

  .upload-demo {
    text-align: center;
  }

  .el-upload-dragger {
    width: 100% !important;
    padding: 20px;
  }

  .upload-tips {
    margin-top: 15px;
    color: #909399;
    font-size: 14px;
    line-height: 1.6;
  }

  .upload-tips p:first-child {
    font-weight: 500;
    margin-bottom: 5px;
  }

  .preview-table {
    margin-top: 20px;
    width: 100%;
  }

  .action-buttons {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
  }

  .footer {
    margin-top: 30px;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }

  .no-data {
    text-align: center;
    padding: 40px 0;
    color: #909399;
  }

  .no-data i {
    font-size: 60px;
    margin-bottom: 15px;
    display: block;
    color: #ebeef5;
  }

  .success-message {
    background-color: #f0f9eb;
    color: #67c23a;
    padding: 15px;
    border-radius: 4px;
    margin-top: 20px;
    display: flex;
    align-items: center;
  }

  .success-message i {
    margin-right: 10px;
    font-size: 18px;
  }

  .file-info {
    margin-top: 15px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 14px;
  }

  .progress-section {
    margin-top: 20px;
  }

  .progress-item {
    margin-bottom: 15px;
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }

  .progress-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .chunk-info {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
  }

  .database-status {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .status-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .status-value {
    font-weight: 500;
  }

  .status-complete {
    color: #67c23a;
  }

  .status-processing {
    color: #e6a23c;
  }

  .status-waiting {
    color: #909399;
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
    }

    .action-buttons {
      flex-direction: column;
      align-items: center;
    }

    .action-buttons .el-button {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .file-type-tabs {
    display: flex;
    margin-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
  }

  .file-type-tab {
    padding: 10px 20px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
  }

  .file-type-tab.active {
    color: #67c23a;
    border-bottom: 2px solid #67c23a;
    font-weight: 500;
  }

  .stats-container {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-top: 20px;
  }

  .stat-card {
    flex: 1;
    min-width: 150px;
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .stat-value {
    font-size: 24px;
    font-weight: bold;
    color: #67c23a;
    margin: 10px 0;
  }

  .stat-label {
    font-size: 14px;
    color: #909399;
  }
</style>
